export enum Role {
  WALLET_MANAGER = "Wallet Manager",
  OPPORTUNITY_MANAGER = "Opportunity Manager",
  ACCESS_MANAGER = "Access Manager",
}
